import { createContext, PropsWithChildren, useContext } from "react";
import { CentraAllocationRuleResponseV1 } from "@made-people/nestjs-bff-service";

export interface AllocationRuleContextValue {
  allocationRule: CentraAllocationRuleResponseV1 | null;
  isLoading: boolean;
  hasWarehouse: (warehouseName: string) => boolean;
}

const AllocationRuleContext = createContext<
  AllocationRuleContextValue | undefined
>(undefined);

export interface MmAllocationRuleProviderProps {
  allocationRule: CentraAllocationRuleResponseV1 | null;
  isLoading: boolean;
}

export const MmAllocationRuleProvider = ({
  children,
  allocationRule,
  isLoading,
}: PropsWithChildren<MmAllocationRuleProviderProps>) => {
  const hasWarehouse = (warehouseName: string): boolean => {
    if (!allocationRule) {
      return false;
    }
    return allocationRule.warehouses.some((w) => w.name === warehouseName);
  };

  return (
    <AllocationRuleContext.Provider
      value={{ allocationRule, isLoading, hasWarehouse }}
    >
      {children}
    </AllocationRuleContext.Provider>
  );
};

export const useAllocationRule = (): AllocationRuleContextValue => {
  const context = useContext(AllocationRuleContext);
  if (!context) {
    throw new Error(
      "useAllocationRule must be used within MmAllocationRuleProvider",
    );
  }
  return context;
};
